
import Tabs from 'primevue/tabs';
import TabList from 'primevue/tablist';
import Tab from 'primevue/tab';
import TabPanels from 'primevue/tabpanels';
import TabPanel from 'primevue/tabpanel';
import IftaLabel from 'primevue/iftalabel';
import Button from 'primevue/button';

import EntertainmentMovie from '../components/entertainment/Movie.vue'
import EntertainmentAnime from '../components/entertainment/Anime.vue'
import EntertainmentAV from '../components/entertainment/AV.vue'

import { ref } from 'vue';
import { useAuthStore } from '../stores/auth';

export default {
	name: 'Entertainment',
	components: {
		EntertainmentMovie,
		EntertainmentAnime,
		EntertainmentAV,
		Tabs,
		TabPanels,
		TabPanel,
		TabList,
		Tab,
		IftaLabel,
		Button,
	},
	setup() {
		const auth = useAuthStore();
		auth.hydrate()

		const tabs = ref<'movie' | 'anime' | 'av'>('movie');

		const tabComponentMap = {
			'movie': EntertainmentMovie,
			'anime': EntertainmentAnime,
			'av': EntertainmentAV,
		};

		return {
			tabs,
			tabComponentMap,
		};
	},
};
